export default __webpack_public_path__ + "static/media/bl9.6f0e5220.png";